import 'features/Weather/assets/timePeriodCard.scss';
import { getDetailContent, getDetailIcon } from 'features/Weather/utils/cardDetails.utils';
import { useId } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';

const TimePeriodCard = ({
  data,
  title,
  subtitleIcon,
  subtitle,
  details = [],
  containerClassName,
  detailsContainerClassName = 'gap-2',
  detailContainerClassName,
  detailLabelClassName,
  headingLevel: Heading = 'h3',
}) => {
  const headingId = useId();
  const hasSubtitle = subtitle !== null && subtitle !== undefined && subtitle !== '';

  return (
    <article
      aria-labelledby={headingId}
      className={joinClasses(
        'weather-time-period-card d-flex h-100 w-100 flex-column align-items-center gap-3 overflow-hidden rounded-3 border p-3 p-sm-4 position-relative',
        containerClassName,
      )}
    >
      <Heading
        id={headingId}
        className="position-relative z-1 m-0 fw-bold weather-time-period-label"
      >
        {title}
      </Heading>

      {(subtitleIcon || hasSubtitle) && (
        <div className="weather-time-period-subtitle-container d-flex flex-column align-items-center justify-content-center position-relative z-1 weather-time-period-main">
          {subtitleIcon && (
            <span
              className="weather-time-period-subtitle-icon d-inline-flex align-items-center justify-content-center"
              aria-hidden="true"
            >
              {subtitleIcon}
            </span>
          )}
          {hasSubtitle && (
            <p className="weather-time-period-subtitle m-0 fw-bold lh-sm">{subtitle}</p>
          )}
        </div>
      )}

      {details.length > 0 && (
        <ul
          className={joinClasses(
            'weather-time-period-details d-grid w-100 position-relative z-1 m-0 list-unstyled',
            detailsContainerClassName,
          )}
        >
          {details.map((detail) => {
            const detailIcon = getDetailIcon(detail, data);

            return (
              <li
                key={detail.id}
                className={joinClasses(
                  'd-flex w-100 align-items-center gap-3 rounded-3 border p-2 weather-time-period-stat',
                  detailContainerClassName,
                )}
              >
                {detailIcon && (
                  <span
                    className="weather-time-period-stat-icon d-inline-flex flex-shrink-0 align-items-center justify-content-center"
                    aria-hidden="true"
                  >
                    {detailIcon}
                  </span>
                )}
                <div className="min-w-0">
                  {detail.label && (
                    <span
                      className={joinClasses(
                        'weather-time-period-detail-label d-block text-uppercase fw-semibold lh-sm',
                        detailLabelClassName,
                      )}
                    >
                      {detail.label}
                    </span>
                  )}
                  <div className="fw-semibold weather-time-period-stat-value">
                    {getDetailContent(detail, data)}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </article>
  );
};

export default TimePeriodCard;
